import "./Errors.css";
import { useTranslation } from "react-i18next";
import error404Image from "../../assets/errors/error404.svg";
import error500Image from "../../assets/errors/error500.svg";
import error500Smiley from "../../assets/errors/error500Smiley.svg";
import { Main } from "../commons/Template/Template";
import { useNavigate, useRouteError } from "react-router-dom";
import { useEffect } from "react";
import routes from "../../routes/routes";
import Typo from "../commons/Typo/Typo";

export default function ErrorBoundary() {
  const error = useRouteError();
  return <ErrorPage code={error.status === 404 ? 404 : 500} />;
}

function ErrorPage({ code }) {
  const { t } = useTranslation(["common", "errors"]);

  document.title = t(`errors:error${code}.title`);
  const navigate = useNavigate();

  useEffect(() => {
    const timerID = setTimeout(() => {
      navigate(routes.Home);
    }, 5 * 1000);
    return () => clearTimeout(timerID);
  }, []);

  const images = {
    404: error404Image,
    500: error500Image,
  };

  return (
    <Main themeSwitch className="ErrorPage">
      <div className="ErrorPage-header">
        <div className="ErrorPage-message">
          <h1>{t(`errors:error${code}.header`)}</h1>
          <Typo>{t(`errors:error${code}.message`)}</Typo>
        </div>
        {code === 500 && (
          <div className="ErrorPage-smiley">
            <img src={error500Smiley} alt=":(" />
          </div>
        )}
      </div>
      <div className="ErrorPage-image">
        <img src={images[code]} alt="Error" />
      </div>
    </Main>
  );
}
